function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", null, React.createElement("path", {
  fill: "#34495E",
  d: "M228,136.8c0,8.395-6.806,15.2-15.2,15.2H15.2C6.806,152,0,145.194,0,136.8V15.2C0,6.805,6.806,0,15.2,0 h197.6c8.395,0,15.2,6.805,15.2,15.2V136.8z"
}), React.createElement("g", null, React.createElement("circle", {
  fill: "#E74C3C",
  cx: 84.913,
  cy: 75.798,
  r: 44.527
}), React.createElement("circle", {
  fill: "#F1C40F",
  cx: 144.739,
  cy: 75.798,
  r: 44.527
}), React.createElement("path", {
  fill: "#F39C12",
  d: "M100.212,75.798c0,13.077,5.638,24.837,14.614,32.982c8.977-8.146,14.614-19.905,14.614-32.982 c0-13.077-5.638-24.837-14.614-32.983C105.85,50.961,100.212,62.721,100.212,75.798z"
})), React.createElement("g", null, React.createElement("path", {
  id: "path4157_1_",
  fill: "#FFFFFF",
  d: "M96.049,90.853l0.795-5.394c-0.434,0-1.072,0.186-1.635,0.186 c-2.209,0-2.452-1.174-2.312-2.042l1.784-11.004h3.356l0.811-5.966h-3.165l0.645-3.709h-6.345 c-0.14,0.14-3.745,20.864-3.745,23.387c0,3.736,2.098,5.399,5.055,5.373C93.609,91.664,95.413,91.023,96.049,90.853z"
}), React.createElement("path", {
  id: "path4155_1_",
  fill: "#FFFFFF",
  d: "M98.06,80.57c0,8.966,5.918,11.097,10.96,11.097c4.654,0,6.702-1.041,6.702-1.041 l1.117-6.119c0,0-3.54,1.56-6.737,1.56c-6.812,0-5.619-5.079-5.619-5.079h12.894c0,0,0.833-4.112,0.833-5.787 c0-4.181-2.081-9.274-9.048-9.274C102.782,65.928,98.06,72.802,98.06,80.57z M109.186,71.608c3.581,0,2.921,4.024,2.921,4.349 h-7.045C105.062,75.542,105.728,71.608,109.186,71.608z"
}), React.createElement("path", {
  id: "path4151_1_",
  fill: "#FFFFFF",
  d: "M149.362,90.85l1.136-6.917c0,0-3.113,1.561-5.25,1.561c-4.5,0-6.306-3.437-6.306-7.128 c0-7.49,3.872-11.611,8.184-11.611c3.232,0,5.827,1.815,5.827,1.815l1.035-6.721c0,0-3.847-1.557-7.146-1.557 c-7.324,0-14.449,6.354-14.449,18.287c0,7.913,3.847,13.14,11.419,13.14C145.953,91.719,149.362,90.85,149.362,90.85z"
}), React.createElement("path", {
  id: "path4149_3_",
  fill: "#FFFFFF",
  d: "M61.154,66.025c-4.351,0-7.686,1.398-7.686,1.398l-0.921,5.466 c0,0,2.753-1.119,6.913-1.119c2.363,0,4.091,0.266,4.091,2.186c0,1.167-0.212,1.597-0.212,1.597s-1.863-0.156-2.726-0.156 c-5.487,0-11.252,2.341-11.252,9.402c0,5.563,3.782,6.84,6.126,6.84c4.476,0,6.405-2.905,6.509-2.914l-0.21,2.425h5.587 l2.492-17.473C69.866,66.264,63.4,66.025,61.154,66.025z M62.514,80.252c0.12,1.067-0.67,6.07-4.489,6.07 c-1.971,0-2.483-1.506-2.483-2.396c0-1.736,0.943-3.821,5.593-3.821C62.215,80.106,62.331,80.223,62.514,80.252z"
}), React.createElement("path", {
  id: "path4145_1_",
  fill: "#FFFFFF",
  d: "M75.805,91.511c1.429,0,9.599,0.363,9.599-8.067c0-7.881-7.562-6.324-7.562-9.49 c0-1.577,1.232-2.073,3.485-2.073c0.895,0,4.336,0.284,4.336,0.284l0.801-5.602c0,0-2.228-0.498-5.854-0.498 c-4.693,0-9.457,1.874-9.457,8.284c0,7.264,7.943,6.534,7.943,9.595c0,2.042-2.219,2.209-3.93,2.209 c-2.96,0-5.625-1.016-5.634-0.968l-0.847,5.546C68.838,90.777,70.481,91.511,75.805,91.511z"
}), React.createElement("path", {
  id: "path4139_1_",
  fill: "#FFFFFF",
  d: "M201.917,60.998l-1.368,8.492c0,0-2.389-3.299-6.127-3.299 c-5.813,0-10.659,7.009-10.659,15.062c0,5.198,2.585,10.292,7.868,10.292c3.801,0,5.907-2.649,5.907-2.649l-0.279,2.263h6.172 l4.847-30.171L201.917,60.998z M198.971,77.556c0,3.352-1.659,7.827-5.099,7.827c-2.284,0-3.354-1.916-3.354-4.925 c0-4.918,2.209-8.164,4.997-8.164C197.799,72.293,198.971,73.862,198.971,77.556z"
}), React.createElement("path", {
  id: "path4133_1_",
  fill: "#FFFFFF",
  d: "M26.801,91.186l3.862-22.778l0.566,22.778h4.372l8.154-22.778l-3.612,22.778h6.495 l5.002-30.212H41.597l-6.255,18.537l-0.325-18.537h-9.259l-5.074,30.212H26.801z"
}), React.createElement("path", {
  id: "path4131_3_",
  fill: "#FFFFFF",
  d: "M124.554,91.228c1.847-10.502,2.189-19.03,6.597-17.469 c0.771-4.065,1.516-5.637,2.357-7.358c0,0-0.395-0.083-1.224-0.083c-2.841,0-4.946,3.882-4.946,3.882l0.565-3.565h-5.907 l-3.958,24.592H124.554z"
}), React.createElement("g", {
  id: "use8523_1_",
  transform: "translate(847.0062,0)"
}, React.createElement("path", {
  id: "path4149_2_",
  fill: "#FFFFFF",
  d: "M-683.004,66.025c-4.351,0-7.686,1.398-7.686,1.398l-0.92,5.466 c0,0,2.753-1.119,6.914-1.119c2.362,0,4.09,0.266,4.09,2.186c0,1.167-0.211,1.597-0.211,1.597s-1.863-0.156-2.727-0.156 c-5.487,0-11.251,2.341-11.251,9.402c0,5.563,3.78,6.84,6.124,6.84c4.477,0,6.406-2.905,6.509-2.914l-0.208,2.425 c0,0,5.584,0,5.586,0l2.492-17.473C-674.29,66.264-680.758,66.025-683.004,66.025z M-681.643,80.252 c0.121,1.067-0.67,6.07-4.491,6.07c-1.97,0-2.481-1.506-2.481-2.396c0-1.736,0.943-3.821,5.592-3.821 C-681.942,80.106-681.827,80.223-681.643,80.252z"
})), React.createElement("g", {
  id: "use8525_1_",
  transform: "translate(442.2857,0)"
}, React.createElement("path", {
  id: "path4131_2_",
  fill: "#FFFFFF",
  d: "M-264.464,91.228c1.847-10.502,2.189-19.03,6.595-17.469 c0.773-4.065,1.519-5.637,2.359-7.358c0,0-0.395-0.083-1.223-0.083c-2.842,0-4.946,3.882-4.946,3.882l0.565-3.565h-5.908 l-3.957,24.592H-264.464z"
}))));

var SvgPayMastercard = function SvgPayMastercard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "228px",
    height: "152px",
    viewBox: "0 0 228 152",
    preserveAspectRatio: "xMinYMin meet",
    enableBackground: "new 0 0 228 152",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPayMastercard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pay-mastercard.d18ce64c.svg";
export { ForwardRef as ReactComponent };